import { Injectable } from '@angular/core';
import {
  CanDeactivate,
  RouterStateSnapshot,
  ActivatedRouteSnapshot,
} from '@angular/router';
import { ShowStoryComponent } from 'app/+stories/show/show.component';
import { FirebaseService } from './firebase.service';

@Injectable()
export class CanDeactivateShowStory
  implements CanDeactivate<ShowStoryComponent> {
  constructor(private firebaseService: FirebaseService) {}

  public canDeactivate(
    component: ShowStoryComponent,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState: RouterStateSnapshot
  ): boolean {
    if (component.story) {
      this.firebaseService.logEvent('story_close', {
        story_id: component.story.id,
        project_id: component.projectId
      });
    }
    return true;
  }
}
